import { render, staticRenderFns } from "./PageMyConnections.vue?vue&type=template&id=056b9526&scoped=true"
import script from "./PageMyConnections.vue?vue&type=script&lang=js"
export * from "./PageMyConnections.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "056b9526",
  null
  
)

export default component.exports